module.exports = __webpack_public_path__ + "media/Onibus.2ea0e13e.mp3";